import firebase from "datastore/database";
import store from "datastore/store";

export default async function fetchPromo(businessUid, promoUid) {
  store.dispatch({ type: "ADD_PROMO_LOADING" });

  const marketingDoc = await firebase
    .firestore()
    .collection("marketing")
    .doc(businessUid)
    .get();
  if (!marketingDoc.exists) {
    store.dispatch({ type: "ADD_PROMO_ERROR" });
    return;
  }
  const marketing = marketingDoc.data();
  let promo;
  if (!marketing.promos) {
    store.dispatch({ type: "ADD_PROMO_ERROR" });
    return;
  }

  // Ooooofff no good
  Object.entries(marketing.promos).forEach((entry) => {
    const [uid, data] = entry;
    if (data.participants.hasOwnProperty(promoUid)) {
      const { participants, ...others } = data;
      promo = { uid, ...others };
    }
  });

  return promo;
}
